import type { ColDef } from 'ag-grid-community';

export const columns: ColDef[] = [
  {
    field: 'rank',
    flex: 1,
    headerName: 'rank',
    headerClass: 'ag-header-cell--rank hideTitle',
    sort: 'asc',
    hide: true,
    context: { useShortLabel: false },
  },
  {
    field: 'team',
    flex: 3,
    headerName: 'team',
    headerClass: 'ag-header-cell--team hideTitle',
    minWidth: 150,
    suppressSizeToFit: true,
    type: 'team',
    context: { useShortLabel: false },
  },
  {
    field: 'played',
    flex: 1,
    headerName: 'played',
    headerClass: 'ag-header-cell--played',
  },
  {
    field: 'won',
    flex: 1,
    headerName: 'won',
    headerClass: 'ag-header-cell--won',
    context: { hiddenUnder: 660 },
  },
  {
    field: 'drawn',
    flex: 1,
    headerName: 'drawn',
    headerClass: 'ag-header-cell--drawn',
    context: { hiddenUnder: 660 },
  },
  {
    field: 'lost',
    flex: 1,
    headerName: 'lost',
    headerClass: 'ag-header-cell--lost',
    context: { hiddenUnder: 660 },
  },
  {
    field: 'goalsFor',
    flex: 1,
    headerName: 'for',
    headerClass: 'ag-header-cell--goalsFor',
    context: { hiddenUnder: 660 },
  },
  {
    field: 'goalsAgainst',
    flex: 1,
    headerName: 'against',
    headerClass: 'ag-header-cell--goalsAgainst',
    context: { hiddenUnder: 660 },
  },
  {
    field: 'goalDifference',
    flex: 1,
    headerName: 'goal_difference',
    headerClass: 'ag-header-cell--goalDifference',
  },
  {
    field: 'points',
    flex: 1,
    headerName: 'points',
    headerClass: 'ag-header-cell--points ag-header-cell--sorted',
    sort: 'desc',
  },
  {
    field: 'formguide',
    flex: 2,
    headerName: 'form_guide',
    headerClass: 'ag-header-cell--formguide',
    suppressSizeToFit: true,
    type: 'formguide',
  },
];
